import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import { Container } from "reactstrap";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import Footer from "../../components/Footer/Footer";
import Dashboard from "../../views/Dashboard/Dashboard";
import StatistiquesUsages from "../../views/StatistiquesUsages/StatistiquesUsages";
import Tags from "../../views/Tags/Tags";
import Tables from "../../views/Base/Tables/Tables";
import Page404 from "../../views/Pages/Page404/Page404";
import { Authorization } from "../../components/withAuth";
import AdminBienEtreRessenti from "../../views/AdminBienEtreRessenti/AdminBienEtreRessenti";
import AdminStatistiquesUsages from "../../views/AdminStatistiquesUsages/AdminStatistiquesUsages";
import AdminDashboard from "../../views/AdminDashboard/AdminDashboard";
import AdminCompanies from "../../views/AdminCompanies/AdminCompanies";
import CompanyWorlds from "../../views/AdminCompanies/CompanyWorlds";
import Worlds from "../../views/Worlds/Worlds";
import WorldResources from "../../views/Worlds/WorldResources";
import { ToastContainer } from "react-toastify";

const user = Authorization(["joueur", "rh", "admin"]);
const rh = Authorization(["rh", "admin"]);
const admin = Authorization(["admin"]);

/**
 * Author Darya OREL et HappyQuest
 * Tous les routes du dashboard
 */
class Full extends Component {

  isRouteCorrect(currentRoute) {
    const correctRoutes = ["/", "/base/tables", "/StatistiquesUsages", "/tags"];
    return correctRoutes.includes(currentRoute) || currentRoute.includes("/admin/");
  }

  /**
   * Darya Orel et HappyQuest
   * Render fonction
   * @return la page à afficher
   */
  render() {
    if (this.isRouteCorrect(this.props.history.location.pathname)) {
      return (
        <div className="app">
          <Header />
          <ToastContainer />
          <div className="app-body">
            <Sidebar {...this.props}/>
            <main className="main">
              <Container fluid>
                <Switch>
                  <Route
                    exact
                    path="/"
                    name="Dashboard"
                    component={rh(Dashboard)}
                  />
                  <Route
                    path="/base/tables"
                    name="Tables"
                    component={rh(Tables)}
                  />
                  //<Route path="/StatistiquesUsages" name="StatistiquesUsages" component={rh(StatistiquesUsages)} />
                  <Route path="/tags" name="Tags" component={rh(Tags)} />
                  <Route path="/admin/Companies" name="Companies" component={admin(AdminCompanies)} />
                  <Route path="/admin/CompanyWorlds/:id" name="CompanyWorlds" component={admin(CompanyWorlds)} />
                  <Route path="/admin/Worlds" name="Worlds" component={admin(Worlds)} />
                  <Route path="/admin/WorldResources/:id" name="WorldResources" component={admin(WorldResources)} />

                  /*<Route
                    path="/admin/StatistiquesUsages/:id"
                    name="AdminStatistiquesUsages"
                    component={admin(AdminStatistiquesUsages)}
                  />
                  <Route
                    path="/admin/BienEtreRessenti/:id"
                    name="AdminBienEtreRessenti"
                    component={admin(AdminBienEtreRessenti)}
                  />*/
                  <Route
                    path="/admin/Dashboard/:id"
                    name="AdminDashboard"
                    component={admin(AdminDashboard)}
                  />
                  <Route component={Page404} />
                </Switch>
              </Container>
            </main>
          </div>
          <Footer />
        </div>
      );
    } else {
      return (
        <Switch>
          <Route component={Page404} />
        </Switch>
      );
    }
  }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js